import { Theme } from '@mui/material/styles';

export const textField = (theme: Theme) => ({
    '& .MuiInputLabel-root': {
        display:'flex',
        flexDirection: 'row-reverse',
        whiteSpace: 'nowrap',

        '&.Mui-focused': {
            color: 'text.secondary',
        },

        '&.Mui-error': {
            color: 'text.secondary',
        },

        '& .MuiFormLabel-asterisk': {
            '&.Mui-focused': {
                color: 'text.secondary',
            },

            '&.Mui-error': {
                color: 'text.secondary',
            },
        },
    },

    '& .MuiInputBase-root': {
        '&.Mui-disabled': {
            '& fieldset': {
                borderColor: 'whiteSmoke.main',
            },
        },

        '& fieldset': {
            borderColor: 'darkGray.main',
            borderWidth: '1px',
            borderRadius: 0,
        },

        '&:hover fieldset': {
            borderColor: 'darkGray.dark',
        },

        '&.Mui-focused fieldset': {
            borderWidth: '1px',
            borderColor: 'darkGray.dark',
        },

        '&.Mui-error fieldset': {
            borderColor: 'darkGray.dark',
        },

        '& .MuiInputBase-input': {
            color: 'text.secondary',
            padding: theme.spacing(1.875),
            fontSize: 14,
            height: '1.1876em',
        }
    },

    '& .MuiFormHelperText-root': {
        marginX: 0,
    },
}) as const;
